export { B2CLoginSocialButtons, default } from './B2CLoginSocialButtons';
